export type PreconnectHint = { origin: string; crossOrigin: boolean };

const addPreconnect = ({ origin, crossOrigin }: PreconnectHint): void => {
  const mode = crossOrigin ? '[crossorigin]' : ':not([crossorigin])';

  if (
    document.head.querySelector(
      `link[rel="preconnect"][href="${origin}"]${mode}`
    )
  ) {
    return;
  }

  const link = document.createElement('link');

  link.rel = 'preconnect';
  link.href = origin;

  if (crossOrigin) {
    link.crossOrigin = '';
  }

  document.head.appendChild(link);
};

/** Adds a `<link rel="preconnect">` per hint not yet in the document head.
 *  Never throws. */
export const preconnect = (hints: PreconnectHint[]): void => {
  try {
    hints.forEach(addPreconnect);
  } catch {
    // A connection hint never stops the page.
  }
};
